import { ListOrdered, Tags, Gift, TrendingUp } from "lucide-react";
import CoverCard from "@/components/cards/CoverCard";
import ScaledCard from "@/components/studio/ScaledCard";

export const SECTIONS = [
  { id: "lista", label: "Listă de preț", hint: "Prețuri pentru saloane", Icon: ListOrdered },
  { id: "sugestie", label: "Sugestie preț vânzare", hint: "Preț recomandat la raft", Icon: Tags },
  { id: "oferte", label: "Oferte active", hint: "Pachete cu discount", Icon: Gift },
  { id: "profit", label: "Profitabilitate", hint: "Cât câștigă salonul", Icon: TrendingUp },
];

export default function PublicHome({ data, width }) {
  return (
    <section className="pub-home" data-testid="section-home">
      <ScaledCard width={width}>
        <CoverCard cover={data.cover} contact={data.contact} />
      </ScaledCard>
    </section>
  );
}
